module.exports = __webpack_public_path__ + "static/media/Health-based-Level03.effe635b.svg";